import { render, staticRenderFns } from "./deliveryProblemDetail.vue?vue&type=template&id=2a2191b4&scoped=true&"
import script from "./deliveryProblemDetail.vue?vue&type=script&lang=js&"
export * from "./deliveryProblemDetail.vue?vue&type=script&lang=js&"
import style0 from "./deliveryProblemDetail.vue?vue&type=style&index=0&id=2a2191b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2191b4",
  null
  
)

export default component.exports